export default __webpack_public_path__ + "static/latest-events-7b9050c8faa76a4207f7cc995807c231.png";